function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0002 23.9163C18.5816 23.9163 23.9168 18.5811 23.9168 11.9997C23.9168 5.41828 18.5816 0.0830078 12.0002 0.0830078C5.41877 0.0830078 0.0834961 5.41828 0.0834961 11.9997C0.0834961 18.5811 5.41877 23.9163 12.0002 23.9163Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0247 11.001H8.0293V12.9963H10.0247V11.001Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.02911 9.00586H6.03369V11.0013H8.02911V9.00586Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.03352 11.001H4.03809V12.9963H6.03352V11.001Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.02911 12.9971H6.03369V14.9925H8.02911V12.9971Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3723 9.43517C19.2316 7.96763 17.965 7.47502 16.3652 7.33432V6.39429H15.1266V7.28069C14.8011 7.28069 14.4683 7.28694 14.1373 7.29318V6.39355H12.8994V7.33322C12.6312 7.33837 10.9837 7.3369 10.9837 7.3369L10.98 8.42901L12.0137 8.43489V15.5926H10.9804L10.9712 16.6693C11.2713 16.6693 12.607 16.6752 12.8964 16.677V17.6049H14.1344V16.699C14.4738 16.7064 14.8029 16.7093 15.124 16.709V17.6053H16.363V16.6814C18.4462 16.5628 19.9049 16.0386 20.086 14.0828C20.233 12.5076 19.4924 11.8053 18.3099 11.5195C19.0285 11.1521 19.4777 10.5089 19.373 9.4348L19.3723 9.43517ZM17.6366 13.8371C17.6366 15.3759 15.0024 15.1999 14.1619 15.2003V12.4724C15.002 12.4724 17.6351 12.2325 17.6355 13.8371H17.6366ZM17.0617 9.98802C17.0617 11.388 14.8635 11.2238 14.1638 11.2238V8.74934C14.8646 8.7497 17.0624 8.52783 17.0617 9.98802Z",
  fill: "white"
});

const SvgTbtcV2 = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTbtcV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tbtc_v2.cd31da98.svg";
export { ForwardRef as ReactComponent };